"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TabTitle = ({ title, tabName, index, selectedTabIndex, handleTabChange, }) => (react_1.default.createElement("li", { className: `tab-item${selectedTabIndex === index ? ' active' : ''}` },
    react_1.default.createElement("div", { className: "tab-item-link", onClick: () => handleTabChange(tabName) }, react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: title } }))));
exports.default = TabTitle;
